


































































































































































































const namespace = 'workshopsSchedule';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import ICalendarData from '@/modules/calendar/interfaces/ICalendarData';
import Guideline from '@/modules/workshops-schedule/components/Guideline.vue';
import Filters from '@/modules/workshops-schedule/components/Filters.vue';
import CalendarDropdownFilters from '@/modules/calendar/components/CalendarDropdownFilters.vue';
import CalendarPills from '@/modules/calendar/components/CalendarPills.vue';
import {
    WeekDay,
    WeekSchedule,
    Workshop,
    Filter,
    Timeline,
} from '@/modules/workshops-schedule/models/weekScheduleModels';
import { Registration, AvailableTicketType } from '@/modules/workshops-schedule/models/formModels';
import { EventTicket } from '../models/EventRegistration';

@Component({
    name: 'Schedule',
    components: {
        Filters,
        Guideline,
        CalendarDropdownFilters,
        CalendarPills,
    },
})
export default class Schedule extends Vue {
    @Getter('loading', { namespace }) private loading!: boolean;
    @Getter('scheduleFilters', { namespace }) private scheduleFilters!: { [id: string]: Filter };
    @Getter('isFilteringVisible', { namespace: 'workshopsSchedule' }) private isFilteringVisible!: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('setLoading', { namespace }) private setLoading: any;
    @Getter('currentEventId', { namespace: 'form' }) private currentEventId!: number;
    @Getter('weekSchedule', { namespace }) private weekSchedule!: WeekSchedule;
    @Getter('weekDays', { namespace }) private weekDays!: WeekDay[];
    @Getter('filteredWeekDays', { namespace }) private filteredWeekDays!: WeekDay[];
    @Getter('timeline', { namespace }) private timeline!: Timeline[];
    @Getter('eventTickets', { namespace }) private participantEventTickets!: EventTicket[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('fetchCurrentWeekDays', { namespace }) private fetchCurrentWeekDays: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('filterWeekDays', { namespace }) private filterWeekDays: any;

    private workshopDetailsModal = false;
    private selectedWorkshop: Workshop = {
        Id: 0,
        Title: '',
        InstructorName: '',
        Image: '',
        Start: '',
        End: '',
        Level: '',
        Description: '',
        WorkshopType: '',
        HasDedicatedTicket: false,
        IncludedInTickets: [],
    };

    private get cssVariables() {
        return (
            '--weekday-width:' +
            100 / this.weekSchedule.WeekDays.length +
            '%; ' +
            '--location-width:' +
            100 / this.weekSchedule.WeekDays[0].Locations.length +
            '%; ' +
            '--room-width:' +
            100 / this.weekSchedule.WeekDays[0].Locations[0].Rooms.length +
            '%; ' +
            '--schedule-board-container-height: 1000px;'
        );
    }

    public async mounted() {
        await this.fetchCurrentWeekDays();
        await this.filterWeekDays();
    }

    private onResourceLoading() {
        this.setLoading(true);
    }

    private onResourceLoadingFinished() {
        this.setLoading(false);
    }

    private displayWorkshopDetails($event: any, workshop: Workshop) {
        this.selectedWorkshop = workshop;
        this.workshopDetailsModal = true;
    }

    private getWorkshopsForTickets(workshops: Workshop[]) {
        const ticketIds = this.participantEventTickets.map(x => x.ticketTypeId);
        if (ticketIds.length === 0) {
            return workshops;
        }

        const participantWorkshops = workshops.filter(
            x => !x.IsVisible || this.intersect(x.IncludedInTickets, ticketIds).length > 0,
        );

        return workshops;
    }

    private isNotIncludedInSelectedTickets(workshop: Workshop) {
        const ticketIds = this.participantEventTickets.map(x => x.ticketTypeId);
        if (ticketIds.length === 0) {
            return false;
        }

        return this.intersect(workshop.IncludedInTickets, ticketIds).length === 0;
    }

    private intersect(arr1: number[], arr2: number[]): number[] {
        return arr1.filter(val1 => {
            return arr2.find(val2 => val1 === val2);
        });
    }

    private getImageUrl(url: string) {
        if (!url) {
            url = '/images/instruktorzy/Thumbnail_ZWF.jpg';
        }
        const pluginDirectory = process.env.VUE_APP_IMAGES_DIR;
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const imgUrl = require(`@/assets${url}`);
        return this.isWordPressPlugin && !imgUrl.startsWith('data:image/jpeg;base64')
            ? pluginDirectory + imgUrl
            : imgUrl;
    }

    private totalNumberOfRooms(weekDays: WeekDay[]) {
        const rooms = weekDays
            .map((l: WeekDay) => l.Locations)
            .reduce((a, b) => a.concat(b), [])
            .map(l => l.Rooms)
            .reduce((a, b) => a.concat(b), []);
        return rooms.length;
    }

    private getWorkshopColor(workshop: Workshop) {
        switch (workshop.WorkshopType) {
            case 'open':
                return this.$vuetify.theme.themes.light.open;
            case 'masterclass':
                return this.$vuetify.theme.themes.light.masterclass;
            case 'theory':
                return this.$vuetify.theme.themes.light.theory;
            case 'party':
                return this.$vuetify.theme.themes.light.party;
            case 'practice':
                return this.$vuetify.theme.themes.light.party;
            default:
                return this.$vuetify.theme.themes.light.kurs;
        }
    }

    protected get isWordPressPlugin() {
        return process.env.VUE_APP_IS_WORDPRESS_PLUGIN === 'true';
    }
}
